import React from 'react';
import ProjectItem from '../../../Domain/ProjectItem';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import selectHelper from '../../../Helpers/selectHelper';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import OperationsProjectService from '../../../Services/OperationsProjectService';

class AddProjectWindowDescription extends React.Component {
  static titleForCreate = 'Add New Project';
  static titleForEdit = 'Add New Project';
  static itemType = ProjectItem;
  static serviceFunction = (edited) => OperationsProjectService.EditProject(edited);

  static pagesInGeneralEditWizzard = [
    {
      label: 'Please provide basic information about this Project.',
      fields: [
        {
          fieldName: 'CfName',
          label: 'Project *',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'CfCoid',
          label: 'Contact *',
          className: 'col-6',
          type: InputTypesEnum.ContactSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
          idFilter: 'ClientId',
        },
        {
          fieldName: 'CfProjectManagerId',
          label: 'Project Manager *',
          className: 'col-12',
          type: InputTypesEnum.ProjectManagerSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'CfStartDate',
          label: 'Start Date *',
          className: 'col-4',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'CfEndDate',
          label: 'End Date *',
          className: 'col-4',
          type: InputTypesEnum.Date,
          validityChecker: AddProjectWindowDescription.validityCheckerForStartAndEndDate,
        },
        {
          fieldName: 'CfRcyid',
          label: 'Billing Currency',
          className: 'col-4',
          type: InputTypesEnum.ActiveCurrencySelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'CfOpportunityId',
          label: 'Opportunity *',
          className: 'col-6',
          type: InputTypesEnum.ProjectOpportunitySelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
          idFilterArray: ['ClientId', 'CfStartDate', 'CfEndDate'],
        },
        {
          fieldName: 'CfServiceId',
          label: 'Service *',
          className: 'col-6',
          type: InputTypesEnum.ProjectServiceSelect,
          idFilter: 'CfOpportunityId',
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'ShopCountInCycle',
          label: 'Shop Count In Cycle',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'CfReimbTypeText',
          label: 'Reimbursement Type',
          className: 'col-6',
          type: InputTypesEnum.Select,
          validityChecker: ValidityHelper.AlwaysFlawless,
          selectvalues: AddProjectWindowDescription.getReimbursementTypeSelectOptions(),
        },
        {
          fieldName: 'CfComments',
          label: 'Summary',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          numberOfRows: 2,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'HasOutsourcedProcessing',
          label: 'Outsourced Processing?',
          className: 'col-6',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.forRequiredBoolField,
        },
        {
          fieldName: 'OutsourcingOfficeIds',
          label: 'Work outsourced to',
          className: 'col-6',
          type: InputTypesEnum.OfficeMultiSelect,
          disabled: (item) => !item.HasOutsourcedProcessing,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
      ],
    },
  ];

  static getReimbursementTypeSelectOptions() {
    return selectHelper.generateSelectValues([
      '',
      'Use Apollo Shopper Reimbursement Field',
      'Use Apollo Client Reimbursement Field',
    ]);
  }

  static validityCheckerForStartAndEndDate(e, editedItem) {
    if (editedItem) {
      return new Date(editedItem.CfStartDate) > new Date(editedItem.CfEndDate)
        ? 'End Date must be later than Start Date.'
        : '';
    }
    return '';
  }
}

export default AddProjectWindowDescription;
